import { useEffect, useState } from "react";

const KEY = "hub_worker_job";

// Selected job for the Worker app; shared by Projects, Timesheets and H&S.
export function useWorkerJob() {
  const [pid, setPid] = useState(() => localStorage.getItem(KEY) || "");
  useEffect(() => {
    const sync = () => setPid(localStorage.getItem(KEY) || "");
    window.addEventListener("worker-job", sync);
    return () => window.removeEventListener("worker-job", sync);
  }, []);
  function choose(id) {
    if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY);
    window.dispatchEvent(new Event("worker-job"));
  }
  return [pid, choose];
}

export function jobLabel(p) {
  return [p.job_number, p.name].filter(Boolean).join(" · ");
}
